import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Form,
  Button,
  InputGroup,
  Alert
} from 'react-bootstrap';


    
import { get_usr_by_email, invite_user } from '../../../../utils/services';
import { create_contact } from '../../../../utils/crm_services';

function Team_link  ({user_id, permission, onSet, onClose}) {

  const token = localStorage.getItem("token");
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');
    const [found, setFound] = useState(null);
    const [userName, setUserName] = useState('');
    const [userId, setuserId] = useState('');
    const [finalEmailID, setfinalemailid] = useState('');

 
    const add_linked_strategy = (id) => {
      onSet(id);
    };


    const findUsr = (emailText) => {
        //Busca un usuario dado un correo electronico lo muestra si lo encontro y habilita para agregarlo
         async function fetchcheckEmail(emailText) {

                const usrData = await get_usr_by_email(token,emailText);
                if (usrData==="INVALID"){
                    navigate("/");
                }else if(usrData==null){
                  setuserId('');
                  setUserName('');
                  setfinalemailid(emailText);
                  setFound(false);
                }
                else{
                    setuserId(usrData[0].id);
                    setfinalemailid(emailText);
                    setUserName(usrData[0].usr_name);
                    setFound(true);
                }
                }
                
                fetchcheckEmail(emailText);
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        findUsr(searchTerm);
      }
    };

   

    function fetch_create_contact(emailText) {

    if (!validateEmail(emailText)) {
      alert("Invalid Email Address: " + emailText);
      return;
    }

    async function fetchInviteNewAddress(emailText) {

      const usrData = await create_contact(token, emailText);
      if (usrData === "INVALID") {
        navigate("/");
      }
      else {
        add_linked_strategy(finalEmailID );
        //onClose(emailText);
      }
    }

    fetchInviteNewAddress(emailText);
  }

     const validateEmail = (email) => {
      // Basic regex for email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    
    return (
      <div className="container py-4">
    
        {/* Barra de búsqueda + menús */}
        {/* mb-4 para más espacio entre la barra y el resultado */}
        {/* align-items-center para alinear verticalmente input y botón si están en la misma fila */}
        <div className="d-flex gap-2 mb-4 flex-wrap align-items-center">
          Escriba el email del usuario al que desea dar acceso a esta oportunidad o distribuidor
          {/* flex-grow-1 y maxWidth para que el input use el espacio disponible hasta un límite */}
          <InputGroup className="flex-grow-1" style={{ maxWidth: 320 }}>
            <Form.Control
              placeholder="email"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='toolbar-control' // Asegúrate de que esta clase está definida si la usas para CSS custom
              onKeyDown={handleKeyDown}
            />
            <Button
              variant="outline-primary" // Mantienes el estilo de contorno
              // Puedes considerar quitar size="sm" para un botón de tamaño estándar si te gusta más
              onClick={() => {
                findUsr(searchTerm);
              }}
            >
              Find
            </Button>
          </InputGroup>
          {/* Aquí irían otros menús si los hubiera, alineados por d-flex y gap-2 */}
        </div>
    
        {found ? (
           <div className="d-flex justify-content-between align-items-center p-3 border rounded">
            <span>
              User found: <strong>{userName}</strong> {/* Resaltamos el nombre */}
            </span>
            <span>
              email: <strong>{searchTerm}</strong> {/* Resaltamos el nombre */}
            </span>
            <Button
              variant="success" // Cambiamos el color del botón "Add" a uno que indique acción positiva
              size="sm" // Mantienes el tamaño pequeño para este botón
              onClick={() => {
                add_linked_strategy(finalEmailID ); // Asegúrate de que userId está accesible aquí
              }}
            >
              Add Contact 
            </Button>
          </div>
        ) : (
              found==false ? ( // Muestra el Alert solo si hay término buscado y no se encontró
                <div className="d-flex flex-column p-3 border rounded">
                <div className="w-100"> {/* Added w-100 to make the div take full width */}
                  <Alert variant="warning" className="w-100"> {/* Added w-100 to the Alert */}
                   {searchTerm} no existe. Creelo para poder invitarlo.
                  </Alert>
                </div>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => {
                    fetch_create_contact(finalEmailID);
                  }}
                  className="w-100 mt-2"
                >
                  Create Contact
                </Button>
              </div>
           ) : null // No renderiza nada si no se ha buscado o si se encontró
        )}
    
      </div>
    );
};

export default Team_link;
